"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiSelectDocumentWithOldDSResponses = void 0;
var multiSelectDocument_1 = require("./multiSelectDocument");
exports.multiSelectDocumentWithOldDSResponses = __assign(__assign({}, multiSelectDocument_1.multiSelectDocument), { responses: [
        {
            answer: "Cherry",
            questionId: 1195204,
            questionRootId: 1195204,
            associatedId: 1190000,
            timeAnswered: "",
        },
        {
            answer: "Aqua",
            questionId: 1195204,
            questionRootId: 1195204,
            associatedId: 1190001,
            timeAnswered: "",
        },
    ] });
//# sourceMappingURL=multiSelectDocumentWithOldDSResponses.js.map